// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_CancelInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/anticipations/cancel/{anticipationId}
 *
 * Cancels an anticipation. No body required — anticipationId is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_CancelInput {}

registerContract('SubaccountsAnticipations_CancelInput', {})
